<template>
  <div class="wrap">
    <div class="login-box">
      <div class="logo">
        <div class="logo-img" :style="'background-image: url(' + require('@/assets/voiceLogo.png') + ')'" />
        <div class="logo-text"><h2>iCabbi Voice+</h2></div>
      </div>
      <b-message type="is-danger" v-if="error">
        {{ error.message }}
        <br />
      </b-message>
      <b-message type="is-success" v-if="success">
        {{ success.message }}
        <br />
      </b-message>
      <transition name="fade" mode="out-in">
        <div class="loginContainer" v-if="mode == 'login'" key="login">
          <b-field label="Email">
            <b-input v-model="username" v-on:keyup.enter="login"></b-input>
          </b-field>
          <b-field label="Password">
            <b-input v-model="pass" v-on:keyup.enter="login" type="password" password-reveal> </b-input>
          </b-field>
          <div class="subtitle is-size-6">Forgot your password? <a class="is-primary" @click="mode = 'reset'">Click here</a> to reset</div>
          <div style="text-align: center">
            <b-button v-on:click="login()" type="is-success">Login</b-button>
          </div>
          <br />
          <p>Don't have an account? <a @click="mode = 'register'">Click here</a> to register</p>
        </div>
        <div class="registerContainer" v-else-if="mode == 'register'" key="register">
          <b-message type="is-danger" v-if="error">
            {{ error.message }}
          </b-message>
          <b-field label="Full Name">
            <b-input v-model="name"></b-input>
          </b-field>
          <b-field label="Email">
            <b-input v-model="username"></b-input>
          </b-field>
          <b-field label="Password">
            <b-input v-model="pass" type="password" password-reveal></b-input>
          </b-field>
          <div class="password-strength">
            <div class="25 red" v-if="this.passwordStrength < 26"></div>
            <div class="25 amber" v-else-if="this.passwordStrength < 76"></div>
            <div class="25 green" v-else-if="this.passwordStrength < 101"></div>
            <div class="50" v-if="this.passwordStrength < 26"></div>
            <div class="50 amber" v-else-if="this.passwordStrength < 76"></div>
            <div class="50 green" v-else-if="this.passwordStrength < 101"></div>
            <div class="75" v-if="this.passwordStrength < 26"></div>
            <div class="75" v-else-if="this.passwordStrength < 76"></div>
            <div class="75 green" v-else-if="this.passwordStrength < 101"></div>
            <div class="100" v-if="this.passwordStrength < 26"></div>
            <div class="100" v-else-if="this.passwordStrength < 76"></div>
            <div class="100 green" v-else-if="this.passwordStrength < 101"></div>
          </div>
          <div style="text-align: center">
            <b-button v-on:click="register()" type="is-success">Register</b-button>
          </div>
          <div>Already have an account? <a @click="mode = 'login'">Click here</a> to Login</div>
        </div>
        <div class="resetContainer is-flex is-flex-direction-column flex-gap-10" v-else-if="mode == 'reset'" key="forgot">
          <div class="is-flex is-flex-direction-column is-align-items-center">
            <h2 class="is-size-5 title">Forgotten Password?</h2>
            <h3 class="is-size-7 subtitle has-text-grey has-text-weight-medium">No worries, we'll guide you through resetting it</h3>
          </div>
          <b-field label="Email" class="is-fullwidth">
            <b-input v-model="username" type="email"></b-input>
          </b-field>
          <b-button type="is-primary is-fullwidth" @click="passwordReset()">Reset Password</b-button>
          <div class="is-flex">
            <b-button type="is-warning is-fullwidth" icon-left="chevron-left" icon-pack="fas" @click="mode = 'login'">Back to login</b-button>
          </div>
        </div>
        <div class="verifyContainer" v-else-if="mode == 'verify'" key="verify">
          <p class="subtitle is-size-6">We've sent you an email with a verification code, please enter it below along with a new password</p>
          <b-field label="Verification Code">
            <b-input v-model="verificationCode"></b-input>
          </b-field>
          <b-field label="New Password">
            <b-input v-model="pass" type="password" password-reveal></b-input>
          </b-field>
          <b-field label="Confirm New Password">
            <b-input v-model="confirmPass" type="password" password-reveal></b-input>
          </b-field>
          <p class="has-text-danger subtitle is-size-6" v-if="pass.length < 7">Password does not meet length requirement</p>
          <p class="has-text-danger subtitle is-size-6" v-if="pass != confirmPass">Passwords do not match</p>
          <b-button type="is-success" class="is-fullwidth" @click="submitPasswordReset()" :disabled="pass.length < 7 && pass != confirmPass">Change Password</b-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  name: "Login",
  data() {
    return {
      username: "",
      name: "",
      pass: "",
      confirmPass: "",
      error: null,
      success: null,
      loading: false,
      apiUrl: "https://api.jeak.co.uk",
      mode: "login",
      passwordStrength: 0,
      strongRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"),
      mediumRegex: new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"),
      enoughRegex: new RegExp("(?=.{8,}).*", "g"),
      approvedEmails: ["discsystems.co.uk", "icabbi.com", "icabbi.ie", "etgl.co.uk"],
      firstNumber: parseInt(Math.random() * 100),
      secondNumber: parseInt(Math.random() * 100),
      operator: this.firstNumber > this.secondNumber ? "+" : "-",
      verificationCode: "",
    };
  },
  methods: {
    login() {
      this.loading = true;
      /*eslint: no-unused-vars: "off"*/
      this.$cognitoAuth.authenticate(this.username, this.pass, (err, result) => {
        if (err) {
          this.error = err;
          this.loading = false;
          this.SendNotification(`Login Attempted - ${this.username}`, "error");
          if (this.error.message == "User is not confirmed.") {
            this.$router.push({ path: "/confirm", query: { email: this.username } });
          }
        } else {
          this.SendNotification(`Login - ${this.username}`, "success");
          this.$router.push("/voiceplus");
        }
      });
    },
    register() {
      this.loading = true;
      let approvedDomainFound = false;
      for (const email of this.approvedEmails) {
        if (this.username.includes("@" + email)) approvedDomainFound = true;
      }
      if (!approvedDomainFound) {
        this.error = {};
        this.error.message = "Sorry, the entered email domain is not on the list of approved domains!";
        this.loading = false;
        this.SendNotification(`${this.name} with email ${this.username} attempted to register`, "error");
        return;
      }
      /*eslint: no-unused-vars: "off"*/
      this.$cognitoAuth.signup(this.username, this.username, this.pass, this.name, (err, result) => {
        if (err) {
          this.error = err;
          this.loading = false;
        } else {
          this.SendNotification(`${this.name} with email ${this.username} registered`, "warning");
          this.$router.push({ path: "/confirm", query: { email: this.username } });
        }
      });
    },
    SendNotification: async function (message, type) {
      const body = {
        message: message,
        type: type,
      };
      axios.post(this.apiUrl + "/notification", body);
    },
    testPassword() {
      if (this.pass.length < 5) {
        this.passwordStrength = 0;
      } else if (this.strongRegex.test(this.pass)) {
        this.passwordStrength = 80;
      } else if (this.mediumRegex.test(this.pass)) {
        this.passwordStrength = 50;
      } else {
        this.passwordStrength = 0;
      }
    },
    async passwordReset() {
      try {
        let response = await this.$cognitoAuth.forgotPassword(this.username);
        if (response == "verify") {
          this.mode = "verify";
        }
      } catch (err) {
        this.error = { message: err.message };
      }
    },
    async submitPasswordReset() {
      let response = await this.$cognitoAuth.updatePassword(this.username, this.verificationCode, this.pass);
      if (response == "true") {
        this.mode = "login";
        this.success = { message: "Password Updated Successfully" };
      }
    },
  },
  mounted() {
    let self = this;

    window.addEventListener("keyup", function (ev) {
      if (ev.key == "Enter") {
        if (self.mode == "login") self.login();
        else self.register();
      }
    });
  },
  watch: {
    mode: function () {
      this.message = null;
      this.error = null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #343470;
  display: flex;
  justify-content: center;
  align-content: center;
}
.login-box {
  width: 400px;
  height: auto;
  background-color: white;
  border-radius: 5px;
  padding: 25px;
  margin: auto;
  border: 1px solid #e4e6e7;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
}
.login-box .logo {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  gap: 10px;
}
.login-box .logo-img {
  height: 90px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.login-box .logo-text {
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 1.3em;
}
.login-box .logo-text h2 {
  font-size: 1.3em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.password-strength {
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-left: 0px;
}

.password-strength div {
  height: 15px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  border: 1px solid #00000059;
  border-radius: 8px;
  box-shadow: 0px 0px 4px -1px grey;
  transition: all 0.2s;
}

.password-strength .red {
  background-color: #ff3535;
  border: 1px solid #cb0000;
}

.password-strength .amber {
  background-color: #ffbc41;
  border: 1px solid #b15200;
}

.password-strength .green {
  background-color: #00d500;
  border: 1px solid #00b700;
}
</style>
